import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { fetchAppConfig } from './appConfig';
import { initSegmentForPostHog } from 'utils/segment';
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(document.getElementById('root')!);

fetchAppConfig()
  .catch((err) => {
    console.error('Failed to load app config:', err);
  })
  .finally(() => {
    initSegmentForPostHog();
    root.render(<App />);
  });

reportWebVitals();
